export default "__VITE_ASSET__BiB7G6nM__"